import { useParams, Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CheckCircle, ShoppingBag, MapPin, Package } from 'lucide-react';

const OrderSuccessPage = () => {
  const { orderId } = useParams();

  return (
    <div className="min-h-screen flex flex-col bg-[#f8fafc]">
      <Navbar />

      <div className="flex-1 flex items-center justify-center py-16 px-4">
        <div className="max-w-md w-full text-center">

          {/* Animated success circle */}
          <div className="relative w-28 h-28 mx-auto mb-8">
            <div className="absolute inset-0 bg-green-100 rounded-full animate-ping opacity-30" />
            <div className="relative w-28 h-28 bg-gradient-to-br from-[#8acb95] to-[#6ab57e] rounded-full flex items-center justify-center shadow-xl">
              <CheckCircle className="w-14 h-14 text-white" />
            </div>
          </div>

          <h1
            className="text-3xl font-bold text-slate-800 mb-3"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Order Placed! 🎉
          </h1>
          <p className="text-slate-500 mb-3 leading-relaxed">
            Thank you for your order. We'll contact you shortly to confirm delivery details.
          </p>
          {orderId && (
            <div className="inline-block bg-green-50 border border-green-100 rounded-xl px-4 py-2 mb-8">
              <p className="text-xs text-slate-400">Order Reference</p>
              <p className="text-sm font-bold text-[#6ab57e] font-mono">{orderId}</p>
            </div>
          )}

          {/* What's next */}
          <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 mb-8 text-left">
            <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">What happens next?</p>
            <div className="space-y-3">
              {[
                { icon: Package, text: 'Your order has been received and is being processed.' },
                { icon: CheckCircle, text: 'Our team will confirm your order via phone or WhatsApp.' },
                { icon: MapPin, text: 'Your items will be delivered to your address.' },
              ].map(({ icon: Icon, text }, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-7 h-7 bg-green-50 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Icon className="w-3.5 h-3.5 text-[#8acb95]" />
                  </div>
                  <p className="text-sm text-slate-600">{text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/products">
              <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#8acb95] hover:bg-[#7bb885] text-white font-semibold px-8 py-3.5 rounded-full transition-all shadow-sm hover:shadow-md text-sm">
                <ShoppingBag className="w-4 h-4" />
                Continue Shopping
              </button>
            </Link>
            <Link to="/track-order">
              <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white border-2 border-slate-200 hover:border-[#8acb95] text-slate-700 hover:text-[#8acb95] font-semibold px-8 py-3.5 rounded-full transition-all text-sm">
                Track My Order
              </button>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OrderSuccessPage;
